<template>
  <div>
    <b-modal
      v-model="showBoardLayout"
      hide-header
      hide-footer
      centered
      class="p-2"
      size="lg"
    >
      <b-img
        class="w-100"
        rounded
        alt="Logo"
        v-for="i in 6"
        :key="i"
        :src="require(`@/assets/images/board_layout_${i}.png`)"
      ></b-img>
    </b-modal>

    <b-form>
      <div class="mt-5 mb-3">
        <div
          class="c-pointer mb-4"
          @click="
            $router.push({
              name: 'site.view-site-page',
              params: {
                id: $route.params.id,
                name: $route.params.name,
                activeBoard: $route.params.topMostParentId
              }
            })
          "
        >
          <b-img
            width="13"
            class="mr-2 mb-1"
            :src="require('@/assets/icons/arrow-left.svg')"
          ></b-img
          >Back to supplied from
        </div>
        <h3>
          <b>General Information</b>
        </h3>
      </div>

      <b-row :class="rowClass">
        <b-col>
          <b-form-group id="input-group-board-name" class="col-12">
            <i
              class="clearable"
              v-show="form.board_name"
              @click="form.board_name = ''"
              >&times;</i
            >

            <b-form-input
              id="input-board-name"
              v-model="form.board_name"
              class="input-effect"
              :class="form.board_name ? 'has-content' : ''"
              type="text"
              required
              aria-describedby="input-board-name-feedback"
            ></b-form-input>
            <label>Board name</label>

            <div class="input-error" v-if="form.$getError('board_name')">
              {{ form.$getError('board_name')[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group id="input-group-location" class="col-12">
            <i
              class="clearable"
              v-show="form.location"
              @click="form.location = ''"
              >&times;</i
            >

            <b-form-input
              id="input-location"
              v-model="form.location"
              class="input-effect"
              :class="form.location ? 'has-content' : ''"
              type="text"
              required
              aria-describedby="input-location-feedback"
            ></b-form-input>
            <label>Location</label>

            <div class="input-error" v-if="form.$getError('location')">
              {{ form.$getError('location')[0] }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row :class="rowClass">
        <b-col>
          <b-form-group id="input-group-cable-size" class="col-12">
            <i
              class="clearable"
              v-show="form.supply_cable_size"
              @click="form.supply_cable_size = ''"
              >&times;</i
            >

            <b-form-input
              id="input-cable-size"
              v-model="form.supply_cable_size"
              class="input-effect"
              :class="form.supply_cable_size ? 'has-content' : ''"
              type="text"
              required
              aria-describedby="input-cable-size-feedback"
            ></b-form-input>
            <label>Supply cable size</label>

            <div class="input-error" v-if="form.$getError('supply_cable_size')">
              {{ form.$getError('supply_cable_size')[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group id="input-group-earth-location" class="col-12">
            <i
              class="clearable"
              v-show="form.main_earth_location"
              @click="form.main_earth_location = ''"
              >&times;</i
            >

            <b-form-input
              id="input-earth-location"
              v-model="form.main_earth_location"
              class="input-effect"
              :class="form.main_earth_location ? 'has-content' : ''"
              type="text"
              required
              aria-describedby="input-earth-location-feedback"
            ></b-form-input>
            <label>Main Earth location</label>

            <div
              class="input-error"
              v-if="form.$getError('main_earth_location')"
            >
              {{ form.$getError('main_earth_location')[0] }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="d-flex justify-content-between mt-4 mb-3">
        <h3>
          <b>Board Layout</b>
          <b-icon
            icon="question-circle"
            aria-label="Help"
            variant="primary"
            class="ml-2 c-pointer pb-1"
            font-scale="0.8"
            @click="showBoardLayout = true"
          ></b-icon>
        </h3>
      </div>

      <b-row :class="rowClass">
        <b-col>
          <b-form-group id="input-group-poles" class="col-12">
            <i
              class="clearable"
              v-show="form.number_of_poles"
              @click="form.number_of_poles = ''"
              >&times;</i
            >

            <b-form-input
              id="input-poles"
              v-model="form.number_of_poles"
              class="input-effect"
              :class="form.number_of_poles ? 'has-content' : ''"
              type="number"
              required
              aria-describedby="input-poles-feedback"
            ></b-form-input>
            <label>Number of poles</label>

            <div class="input-error" v-if="form.$getError('number_of_poles')">
              {{ form.$getError('number_of_poles')[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group id="input-group-numbering-format" class="col-12">
            <b-img
              class="append-icon"
              :src="require('@/assets/icons/chevron-secondary.svg')"
              @click="select.numbering_format = !select.numbering_format"
            ></b-img>
            <b-form-input
              id="input-numbering-format"
              v-model="form.numbering_format"
              class="input-effect"
              :class="form.numbering_format ? 'has-content' : ''"
              :readonly="true"
              type="text"
              required
              aria-describedby="input-numbering-format-feedback"
              @focus="select.numbering_format = true"
              @blur="select.numbering_format = false"
            ></b-form-input>
            <label>Numbering format</label>

            <ul v-show="select.numbering_format" @mousedown.prevent>
              <li @click="onSelect('numbering_format', 'Horizontal')">
                Horizontal
              </li>
              <li @click="onSelect('numbering_format', 'Vertical')">
                Vertical
              </li>
              <li @click="onSelect('numbering_format', 'Blank')">
                Blank
              </li>
            </ul>

            <div class="input-error" v-if="form.$getError('numbering_format')">
              {{ form.$getError('numbering_format')[0] }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row :class="rowClass">
        <b-col>
          <b-form-group id="input-group-phase-colouring" class="col-12">
            <b-img
              class="append-icon"
              :src="require('@/assets/icons/chevron-secondary.svg')"
              @click="select.is_phase_colouring = !select.is_phase_colouring"
            ></b-img>
            <b-form-input
              id="input-phase-colouring"
              v-model="form.is_phase_colouring"
              class="input-effect"
              :class="form.is_phase_colouring ? 'has-content' : ''"
              :readonly="true"
              type="text"
              required
              aria-describedby="input-phase-colouring-feedback"
              @focus="select.is_phase_colouring = true"
              @blur="select.is_phase_colouring = false"
            ></b-form-input>
            <label>Phase colouring</label>

            <ul v-show="select.is_phase_colouring" @mousedown.prevent>
              <li @click="onSelect('is_phase_colouring', 'Yes')">Yes</li>
              <li @click="onSelect('is_phase_colouring', 'No')">No</li>
            </ul>

            <div
              class="input-error"
              v-if="form.$getError('is_phase_colouring')"
            >
              {{ form.$getError('is_phase_colouring')[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group id="input-group-phase-numbering" class="col-12">
            <b-img
              class="append-icon"
              :src="require('@/assets/icons/chevron-secondary.svg')"
              @click="select.is_phase_numbering = !select.is_phase_numbering"
            ></b-img>
            <b-form-input
              id="input-phase-numbering"
              v-model="form.is_phase_numbering"
              class="input-effect"
              :class="form.is_phase_numbering ? 'has-content' : ''"
              :readonly="true"
              type="text"
              required
              aria-describedby="input-phase-numbering-feedback"
              @focus="select.is_phase_numbering = true"
              @blur="select.is_phase_numbering = false"
            ></b-form-input>
            <label>Phase numbering</label>

            <ul v-show="select.is_phase_numbering" @mousedown.prevent>
              <li @click="onSelect('is_phase_numbering', 'Yes')">Yes</li>
              <li @click="onSelect('is_phase_numbering', 'No')">No</li>
            </ul>

            <div
              class="input-error"
              v-if="form.$getError('is_phase_numbering')"
            >
              {{ form.$getError('is_phase_numbering')[0] }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row :class="rowClass">
        <b-col>
          <b-form-group id="input-group-neutral-numbers" class="col-12">
            <b-img
              class="append-icon"
              :src="require('@/assets/icons/chevron-secondary.svg')"
              @click="select.is_neutral_numbers = !select.is_neutral_numbers"
            ></b-img>
            <b-form-input
              id="input-neutral-numbers"
              v-model="form.is_neutral_numbers"
              class="input-effect"
              :class="form.is_neutral_numbers ? 'has-content' : ''"
              :readonly="true"
              type="text"
              required
              aria-describedby="input-neutral-numbers-feedback"
              @focus="select.is_neutral_numbers = true"
              @blur="select.is_neutral_numbers = false"
            ></b-form-input>
            <label>Neutral numbers</label>

            <ul v-show="select.is_neutral_numbers" @mousedown.prevent>
              <li @click="onSelect('is_neutral_numbers', 'Yes')">Yes</li>
              <li @click="onSelect('is_neutral_numbers', 'No')">No</li>
            </ul>

            <div
              class="input-error"
              v-if="form.$getError('is_neutral_numbers')"
            >
              {{ form.$getError('is_neutral_numbers')[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group id="input-group-board-colour" class="col-12">
            <b-img
              class="append-icon"
              :src="require('@/assets/icons/chevron-secondary.svg')"
              @click="select.board_colour = !select.board_colour"
            ></b-img>
            <b-form-input
              id="input-board-colour"
              v-model="form.board_colour"
              class="input-effect"
              :class="form.board_colour ? 'has-content' : ''"
              :readonly="true"
              type="text"
              required
              aria-describedby="input-board-colour-feedback"
              @focus="select.board_colour = true"
              @blur="select.board_colour = false"
            ></b-form-input>
            <label>Board colour</label>

            <ul v-show="select.board_colour" @mousedown.prevent>
              <li
                v-for="color in boardColours"
                :key="color.name"
                @click="onSelect('board_colour', color.name)"
              >
                {{ color.name }}
                <b-img
                  v-bind="colorProps"
                  rounded
                  alt="Rounded image"
                  :blank-color="color.hex"
                ></b-img>
              </li>
            </ul>

            <div class="input-error" v-if="form.$getError('board_colour')">
              {{ form.$getError('board_colour')[0] }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <!--       <div class="mt-4 mb-3">
        <h3>
          <b>Testing Information</b>
        </h3>
      </div>

      <b-row :class="rowClass">
        <b-col>
          <b-form-group id="input-group-date-tested" class="col-12">
            <i
              class="clearable"
              v-show="form.rcd_date_tested"
              @click="form.rcd_date_tested = ''"
              >&times;</i
            >

            <b-form-input
              id="input-date-tested"
              v-model="form.rcd_date_tested"
              class="input-effect"
              :class="form.rcd_date_tested ? 'has-content' : ''"
              type="text"
              required
              aria-describedby="input-date-tested-feedback"
              :placeholder="focus.rcd_date_tested ? 'DD/MM/YY' : ''"
              @focus="focus.rcd_date_tested = true"
              @blur="focus.rcd_date_tested = false"
              @keyup="formatDateInput($event, 'rcd_date_tested')"
            ></b-form-input>
            <label>RCD date tested</label>

            <div class="input-error" v-if="form.$getError('rcd_date_tested')">
              {{ form.$getError('rcd_date_tested')[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group id="input-group-testing-due" class="col-12">
            <i
              class="clearable"
              v-show="form.rcd_testing_due"
              @click="form.rcd_testing_due = ''"
              >&times;</i
            >

            <b-form-input
              id="input-testing-due"
              v-model="form.rcd_testing_due"
              class="input-effect"
              :class="form.rcd_testing_due ? 'has-content' : ''"
              type="text"
              required
              aria-describedby="input-testing-due-feedback"
              :placeholder="focus.rcd_testing_due ? 'DD/MM/YY' : ''"
              @focus="focus.rcd_testing_due = true"
              @blur="focus.rcd_testing_due = false"
              @keyup="formatDateInput($event, 'rcd_testing_due')"
            ></b-form-input>
            <label>RCD testing due</label>

            <div class="input-error" v-if="form.$getError('rcd_testing_due')">
              {{ form.$getError('rcd_testing_due')[0] }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row :class="rowClass">
        <b-col>
          <b-form-group id="input-group-imaging-tested" class="col-12">
            <i
              class="clearable"
              v-show="form.thermal_imaging_tested"
              @click="form.thermal_imaging_tested = ''"
              >&times;</i
            >

            <b-form-input
              id="input-imaging-tested"
              v-model="form.thermal_imaging_tested"
              class="input-effect"
              :class="form.thermal_imaging_tested ? 'has-content' : ''"
              type="text"
              required
              aria-describedby="input-imaging-tested-feedback"
              :placeholder="focus.thermal_imaging_tested ? 'DD/MM/YY' : ''"
              @focus="focus.thermal_imaging_tested = true"
              @blur="focus.thermal_imaging_tested = false"
              @keyup="formatDateInput($event, 'thermal_imaging_tested')"
            ></b-form-input>
            <label>Thermal imaging tested</label>

            <div
              class="input-error"
              v-if="form.$getError('thermal_imaging_tested')"
            >
              {{ form.$getError('thermal_imaging_tested')[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group id="input-group-imaging-due" class="col-12">
            <i
              class="clearable"
              v-show="form.thermal_imaging_due"
              @click="form.thermal_imaging_due = ''"
              >&times;</i
            >

            <b-form-input
              id="input-imaging-due"
              v-model="form.thermal_imaging_due"
              class="input-effect"
              :class="form.thermal_imaging_due ? 'has-content' : ''"
              type="text"
              required
              aria-describedby="input-imaging-due-feedback"
              :placeholder="focus.thermal_imaging_due ? 'DD/MM/YY' : ''"
              @focus="focus.thermal_imaging_due = true"
              @blur="focus.thermal_imaging_due = false"
              @keyup="formatDateInput($event, 'thermal_imaging_due')"
            ></b-form-input>
            <label>Thermal imaging due</label>

            <div
              class="input-error"
              v-if="form.$getError('thermal_imaging_due')"
            >
              {{ form.$getError('thermal_imaging_due')[0] }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row :class="rowClass">
        <b-col>
          <b-form-group id="input-group-last-tested" class="col-12">
            <i
              class="clearable"
              v-show="form.date_last_tested"
              @click="form.date_last_tested = ''"
              >&times;</i
            >

            <b-form-input
              id="input-last-tested"
              v-model="form.date_last_tested"
              class="input-effect"
              :class="form.date_last_tested ? 'has-content' : ''"
              type="text"
              required
              aria-describedby="input-last-tested-feedback"
              :placeholder="focus.date_last_tested ? 'DD/MM/YY' : ''"
              @focus="focus.date_last_tested = true"
              @blur="focus.date_last_tested = false"
              @keyup="formatDateInput($event, 'date_last_tested')"
            ></b-form-input>
            <label>Emergency lighting tested</label>

            <div class="input-error" v-if="form.$getError('date_last_tested')">
              {{ form.$getError('date_last_tested')[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group id="input-group-date-due" class="col-12">
            <i
              class="clearable"
              v-show="form.date_due_next"
              @click="form.date_due_next = ''"
              >&times;</i
            >

            <b-form-input
              id="input-date-due"
              v-model="form.date_due_next"
              class="input-effect"
              :class="form.date_due_next ? 'has-content' : ''"
              type="text"
              required
              aria-describedby="input-date-due-feedback"
              :placeholder="focus.date_due_next ? 'DD/MM/YY' : ''"
              @focus="focus.date_due_next = true"
              @blur="focus.date_due_next = false"
              @keyup="formatDateInput($event, 'date_due_next')"
            ></b-form-input>
            <label>Emergency lighting due</label>

            <div class="input-error" v-if="form.$getError('date_due_next')">
              {{ form.$getError('date_due_next')[0] }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row :class="rowClass">
        <b-col>
          <b-form-group id="input-group-notes" class="col-12">
            <i class="clearable" v-show="form.notes" @click="form.notes = ''"
              >&times;</i
            >

            <b-form-textarea
              id="input-notes"
              v-model="form.notes"
              class="input-effect overflow-auto pt-4"
              :class="form.notes ? 'has-content' : ''"
              type="text"
              required
              aria-describedby="input-notes-feedback"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <label>Notes</label>

            <div class="input-error" v-if="form.$getError('notes')">
              {{ form.$getError('notes')[0] }}
            </div>
          </b-form-group>
        </b-col>
      </b-row> -->

      <div class="mt-4 mb-3">
        <h3>
          <b>Metering Information</b>
        </h3>
      </div>

      <b-row :class="rowClass">
        <b-col>
          <b-form-group id="input-group-nmi" class="col-12">
            <i
              class="clearable"
              v-show="form.account_number"
              @click="form.account_number = ''"
              >&times;</i
            >

            <b-form-input
              id="input-nmi"
              v-model="form.account_number"
              class="input-effect"
              :class="form.account_number ? 'has-content' : ''"
              required
              aria-describedby="input-nmi-feedback"
            ></b-form-input>
            <label>NMI or account number</label>

            <div class="input-error" v-if="form.$getError('account_number')">
              {{ form.$getError('account_number')[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group id="input-group-meter-1" class="col-12">
            <i
              class="clearable"
              v-show="form.meter_number_1"
              @click="form.meter_number_1 = ''"
              >&times;</i
            >

            <b-form-input
              id="input-meter-1"
              v-model="form.meter_number_1"
              class="input-effect"
              :class="form.meter_number_1 ? 'has-content' : ''"
              required
              aria-describedby="input-meter-1-feedback"
            ></b-form-input>
            <label>Meter number 1</label>

            <div class="input-error" v-if="form.$getError('meter_number_1')">
              {{ form.$getError('meter_number_1')[0] }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row :class="rowClass">
        <b-col>
          <b-form-group id="input-group-meter-2" class="col-12">
            <i
              class="clearable"
              v-show="form.meter_number_2"
              @click="form.meter_number_2 = ''"
              >&times;</i
            >

            <b-form-input
              id="input-meter-2"
              v-model="form.meter_number_2"
              class="input-effect"
              :class="form.meter_number_2 ? 'has-content' : ''"
              required
              aria-describedby="input-meter-2-feedback"
            ></b-form-input>
            <label>Meter number 2</label>

            <div class="input-error" v-if="form.$getError('meter_number_2')">
              {{ form.$getError('meter_number_2')[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group id="input-group-meter-3" class="col-12">
            <i
              class="clearable"
              v-show="form.meter_number_3"
              @click="form.meter_number_3 = ''"
              >&times;</i
            >

            <b-form-input
              id="input-meter-3"
              v-model="form.meter_number_3"
              class="input-effect"
              :class="form.meter_number_3 ? 'has-content' : ''"
              required
              aria-describedby="input-meter-3-feedback"
            ></b-form-input>
            <label>Meter number 3</label>

            <div class="input-error" v-if="form.$getError('meter_number_3')">
              {{ form.$getError('meter_number_3')[0] }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-button
        class="mt-5"
        block
        variant="primary"
        :disabled="loading"
        @click="onSubmit"
      >
        <b-spinner class="mr-2" small v-show="loading"></b-spinner>Create Board
      </b-button>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Form from '@/utils/form'
import { findIndex } from 'lodash'

const COLORS = [
  { name: 'White', hex: '#FFFFFF' },
  { name: 'Cream', hex: '#F0E9DE' },
  { name: 'Grey', hex: '#909B93' },
  { name: 'Blue', hex: '#5B6E98' },
  { name: 'Orange', hex: '#DE8D45' },
  { name: 'Red', hex: '#B63824' },
  { name: 'Black', hex: '#000000' },
  { name: 'Green', hex: '#31573D' }
]

export default {
  computed: {
    ...mapState({
      board: state => state.board.boardDetails
    }),

    rowClass() {
      return this.isMobile ? 'd-block' : ''
    }
  },

  data() {
    return {
      loading: false,
      show: false,
      showBoardLayout: false,
      boardColours: COLORS,
      colorProps: {
        blank: true,
        width: 18,
        height: 18,
        border: '1px',
        borderColor: 'grey',
        position: 'absolute',
        right: true,
        class: 'mt-1'
      },
      select: {
        numbering_format: false,
        is_phase_colouring: false,
        is_phase_numbering: false,
        is_neutral_numbers: false,
        board_colour: false
      },
      // focus: {
      //   rcd_date_tested: false,
      //   rcd_testing_due: false,
      //   thermal_imaging_tested: false,
      //   thermal_imaging_due: false,
      //   date_last_tested: false,
      //   date_due_next: false
      // },
      form: new Form({
        site_id: null,
        parent_id: null,
        board_name: null,
        supply_cable_size: null,
        location: null,
        main_earth_location: null,
        number_of_poles: null,
        numbering_format: null,
        is_phase_colouring: null,
        is_phase_numbering: null,
        is_neutral_numbers: null,
        board_colour: null,
        // rcd_date_tested: null,
        // rcd_testing_due: null,
        // thermal_imaging_tested: null,
        // thermal_imaging_due: null,
        // date_last_tested: null,
        // date_due_next: null,
        // notes: null,
        account_number: null,
        meter_number_1: null,
        meter_number_2: null,
        meter_number_3: null
      })
    }
  },

  methods: {
    ...mapActions({
      createBoard: 'board/createBoard'
    }),

    checkValue(str, max) {
      if (str.charAt(0) !== '0' || str === '00') {
        let num = parseInt(str)
        if (isNaN(num) || num <= 0 || num > max) {
          num = 1
        }
        str =
          num > parseInt(max.toString().charAt(0)) &&
          num.toString().length === 1
            ? '0' + num
            : num.toString()
      }
      return str
    },

    // formatDateInput(e, field) {
    //   let input = e.target.value
    //   if (/\D\/$/.test(input)) {
    //     input = input.substr(0, input.length - 3)
    //   }

    //   let values = input.split('/').map(function(v) {
    //     return v.replace(/\D/g, '')
    //   })
    //   if (values[0]) {
    //     values[0] = this.checkValue(values[0], 31)
    //   }
    //   if (values[1]) {
    //     values[1] = this.checkValue(values[1], 12)
    //   }

    //   let output = values.map(function(v, i) {
    //     return v.length === 2 && i < 2 ? v + '/' : v
    //   })

    //   this.form[field] = output.join('').substr(0, 8)
    // },

    onSelect(field, value) {
      this.select[field] = false
      this.form[field] = value
    },

    resetForm() {
      this.form.site_id = this.$route.params.id
      this.form.parent_id = this.$route.params.parentId
      this.scrollToTop()
      this.form.$clearErrors()
    },

    // parseDate(date) {
    //   return date
    //     ? `20${date[6]}${date[7]}-${date[3]}${date[4]}-${date[0]}${date[1]}`
    //     : null
    // },

    async onSubmit() {
      this.loading = true
      const colorIndex = findIndex(this.boardColours, {
        name: this.form.board_colour
      })
      await this.createBoard({
        site_id: this.form.site_id,
        parent_id: this.form.parent_id,
        board_name: this.form.board_name,
        supply_cable_size: this.form.supply_cable_size,
        location: this.form.location,
        main_earth_location: this.form.main_earth_location,
        number_of_poles: this.form.number_of_poles,
        numbering_format: this.form.numbering_format
          ? this.form.numbering_format.toLowerCase()
          : null,
        is_phase_colouring: this.form.is_phase_colouring
          ? this.form.is_phase_colouring === 'Yes'
          : null,
        is_phase_numbering: this.form.is_phase_numbering
          ? this.form.is_phase_numbering === 'Yes'
          : null,
        is_neutral_numbers: this.form.is_neutral_numbers
          ? this.form.is_neutral_numbers === 'Yes'
          : null,
        board_colour:
          colorIndex !== -1 ? this.boardColours[colorIndex].hex : null,
        // rcd_date_tested: this.parseDate(this.form.rcd_date_tested),
        // rcd_testing_due: this.parseDate(this.form.rcd_testing_due),
        // thermal_imaging_tested: this.parseDate(
        //   this.form.thermal_imaging_tested
        // ),
        // thermal_imaging_due: this.parseDate(this.form.thermal_imaging_due),
        // date_last_tested: this.parseDate(this.form.date_last_tested),
        // date_due_next: this.parseDate(this.form.date_due_next),
        // notes: this.form.notes,
        account_number: this.form.account_number,
        meter_number_1: this.form.meter_number_1,
        meter_number_2: this.form.meter_number_2,
        meter_number_3: this.form.meter_number_3
      })
        .then(() => {
          this.$router.push({
            name: 'board.board-details-page',
            params: { id: this.board.board_id, name: this.$route.params.name }
          })
        })
        .catch(error => {
          this.form.$handleError(error)
        })
      this.loading = false
    }
  },

  created() {
    this.resetForm()
  }
}
</script>

<style lang="scss" scoped>
.append-icon {
  top: 16px;
  right: 14px;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #f8f9fa;
}
.append-icon {
  z-index: 1;
}
.buttontext {
  font-size: 14px;
  font-weight: bold;
}
.buttontext-2 {
  color: grey;
  font-size: 14px;
}
ul {
  position: absolute;
  z-index: 2;
  list-style-type: none;
  margin: 0;
  padding: 0;
  background: #f8f9fa;
  width: 100%;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  margin-top: 2px;
  cursor: pointer;

  li {
    padding: 8px 16px;

    &:hover {
      background: #296dc529;
    }
  }
}
</style>
